import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { selectCatalogCurrentProductDetails } from '@core/state/design-tool/design-tool.selectors';
import { Store } from '@ngrx/store';
import { Observable, catchError, map, of } from 'rxjs';

import * as DesignToolActions from '@core/state/design-tool/design-tool.actions';

@Injectable({
  providedIn: 'root'
})
export class CatalogProductDetailsResolver  {
  constructor(
    private store: Store
  ){}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const brand = route.params.brand;
    const style = route.params.style;
    this.store.dispatch(DesignToolActions.getCatalogProductDetails({brand, style}));

    return this.store.select(selectCatalogCurrentProductDetails).pipe(
      // Map the result to a boolean value indicating whether product details exist
      map(productDetails => !!productDetails),
      // Catch any errors and return false if an error occurs
      catchError(() => of(false))
    );
  }
}
